import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MarketService {

  constructor(private http: HttpClient) { }

  getMarketHistory(paramval?: any) {
    return this.http.post<any>('/api/Market/GetMarketHistory', JSON.stringify(paramval));
  }
  getMarketHistoryDetails(paramval?: any) {
    return this.http.post<any>('/api/Market/GetMarketHistoryDetails', JSON.stringify(paramval));
  }
  getRoundHistory(paramval?: any) {
    return this.http.post<any>('/api/Market/GetRoundHistory', JSON.stringify(paramval));
  }
}
